import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { SafelyRenderHtml } from '@src/services';

const BundleSection = ({ data }) => {
    const {
        heading,
        list_html: listHtml,
        cta_label: ctaLabel,
        cta_url: ctaUrl,
        icon,
    } = data || {};

    const iconSrc = icon ? `/img/icons/${icon}` : null;
    const iconImage = iconSrc
        ? (
            <img
                alt="An icon representing a bundle"
                height={73}
                src={iconSrc}
                width={73}
            />
        )
        : null;

    return (
        <section id="bundle" className="col-12 p-0">
            <div className="container-fluid p-0 bg-color">
                <Row className="bundles-module main-container-row">
                    <Col lg={3} className="image-bundles text-center">
                        {
                            iconImage && ctaUrl
                                ? (
                                    <a
                                        className="ml-button-primary rounded"
                                        href={ctaUrl}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        {iconImage}
                                    </a>
                                )
                                : iconImage
                        }
                    </Col>
                    <Col>
                        {heading && <h2>{SafelyRenderHtml(heading)}</h2>}
                        {listHtml && SafelyRenderHtml(listHtml)}
                        {
                            ctaLabel && ctaUrl
                            && (
                                <div className="links-m">
                                    <a
                                        className="ml-button-primary"
                                        href={ctaUrl}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        {SafelyRenderHtml(ctaLabel)}
                                    </a>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            </div>
        </section>
    );
};

BundleSection.propTypes = {
    data: PropTypes.shape({
        heading: PropTypes.string,
        list_html: PropTypes.string,
        cta_label: PropTypes.string,
        cta_url: PropTypes.string,
        icon: PropTypes.string,
    }),
};

export default BundleSection;
